import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const CountUp = ({ to, duration = 2 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = null;
    let raf;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(to * eased));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, to, duration]);

  return <span ref={ref}>{value.toLocaleString("it-IT")}</span>;
};

const STATS = [
  { value: 1240, suffix: "+", label: "ore di libertà restituite alle nostre clienti" },
  { value: 7, suffix: "", label: "giorni per vedere il primo cambiamento" },
  { value: 30, suffix: "", label: "giorni di piano d'azione per consolidare" },
];

export const Counter = () => (
  <section data-testid="counter-section" className="border-y border-ink/10 bg-fango-light py-16 sm:py-20">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 text-center sm:grid-cols-3 sm:px-8">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: i * 0.15 }}
        >
          <p className="font-serif text-5xl text-ink sm:text-6xl">
            <CountUp to={s.value} />
            <span className="text-terracotta">{s.suffix}</span>
          </p>
          <p className="mx-auto mt-3 max-w-[16rem] text-xs font-medium uppercase tracking-[0.18em] text-taupe">
            {s.label}
          </p>
        </motion.div>
      ))}
    </div>
  </section>
);
